import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class DeleteDataBaseComponent extends BaseComponent {
  public text: string = "DeleteData";

  constructor(userService: UserService) {
    super(userService);
  }
}
